import React from 'react';
import OrangeButton from '../components/OrangeButton';

const OrangePage = () => {
  return (
    <div className="container mx-auto p-4">
      <div className="card w-full bg-base-100 shadow-xl">
        <div className="card-body">
          <h1 className="card-title text-3xl">Orange Management</h1>
          <OrangeButton />
        </div>
      </div>
    </div>
  );
};

export default OrangePage;
